var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconLabelSheets = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    d: "M34.33 1H5.67a.76.76 0 0 0-.76.76v36.49c0 .42.34.76.76.76h28.67c.42 0 .76-.34.76-.76V1.76a.76.76 0 0 0-.76-.76Zm-.76 36.49H6.42V2.51h27.15v34.97Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    d: "M9.49 35.05h8.49c.42 0 .76-.34.76-.76V22.1a.76.76 0 0 0-.76-.76H9.49a.76.76 0 0 0-.76.76v12.19c0 .42.34.76.76.76Zm.76-12.19h6.98v10.72h-6.98V22.86ZM22.02 35.05h8.49c.42 0 .76-.34.76-.76V22.1a.76.76 0 0 0-.76-.76h-8.49a.76.76 0 0 0-.76.76v12.19c.04.42.34.76.76.76Zm.76-12.19h6.98v10.72h-6.98V22.86ZM9.49 18.78h8.49c.42 0 .76-.34.76-.76V5.83a.76.76 0 0 0-.76-.76H9.49a.76.76 0 0 0-.76.76v12.19c0 .42.34.76.76.76Zm.76-12.19h6.98v10.72h-6.98V6.59ZM22.02 18.78h8.49c.42 0 .76-.34.76-.76V5.83a.76.76 0 0 0-.76-.76h-8.49a.76.76 0 0 0-.76.76v12.19c.04.42.34.76.76.76Zm.76-12.19h6.98v10.72h-6.98V6.59Z"
  })));
};
export default SvgIconLabelSheets;